export function filterTable(inputElement, columnClass) {
    const tableName = '.js-sparePartsList';
    const filter = inputElement.value.toUpperCase();
    const table = document.querySelector(tableName);
    let resultsFound = false;

    // Nachrichtenelement erstellen, falls es nicht existiert
    let noResultsMessage = document.querySelector('.no-results-message');
    if (!noResultsMessage) {
        noResultsMessage = document.createElement('tr');
        noResultsMessage.className = 'no-results-message';
        noResultsMessage.innerHTML = '<td colspan="100%">Keine Ergebnisse gefunden</td>';
        table.appendChild(noResultsMessage);
    }

    table.querySelectorAll('.table__row').forEach(row => {
        const cell = row.querySelector(columnClass);
        if (cell !== null) {
            if (cell.textContent.toUpperCase().indexOf(filter) > -1) {
                if (row.style.display !== 'none' || filter === '') {
                    row.style.display = '';
                    resultsFound = true; // Ein Ergebnis wurde gefunden
                }
            } else {
                row.style.display = 'none';
            }
        }
    });

    // Nachricht anzeigen oder ausblenden
    if (resultsFound) {
        noResultsMessage.style.display = 'none';
    } else {
        noResultsMessage.style.display = '';
    }
}
